import axios from 'axios';
import promise from 'promise';

// lodash
import extend from 'lodash/extend';

import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import User from 'app/shared/model/User';

// service
import appLogger from 'app/shared/loggers/appLogger';

const UserActions = {
    addReferral({ code }) {
        return (dispatch, getState) => dispatch(api.users.referrals.add({ code }))
            .then((response) => {
                const { error: errorRMWModel, success } = response;

                if (success) {
                    return response.response;
                }

                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'UserActions.addReferral',
                    user: getState().user,
                });

                return promise.reject(errorRMWModel);
            });
    },

    getUser({ pageWithSensitiveInformation = false, includeSummary = false } = {}) {
        return dispatch => dispatch(api.users.getUser({ pageWithSensitiveInformation, includeSummary }))
            .then((response = {}) => {
                const { error: errorRMWModel, success } = response;

                if (success && response.response) {
                    const userModel = User(response.response);

                    dispatch(UserActions.updateUserInfo(userModel));
                    // for client auth purposes
                    return response.response;
                }
                return promise.reject(errorRMWModel);
            })
            .catch((errorRMWModel) => {
                // dispatch
                global.TEMPORARY_global_logger.error(errorRMWModel);
                return promise.reject(errorRMWModel);
            });
    },

    getAccountSettings() {
        return dispatch => dispatch(api.users.getSettings())
            .then((data = {}) => {
                const { success, response } = data;

                if (success && response.settings) {
                    return {
                        phoneNumber: response.settings.accountPhoneNumber,
                    };
                }
                global.TEMPORARY_global_logger.error(data, 'Error fetching user settings - UserActions');
                return {
                    phoneNumber: 'Error retrieving phone number',
                };
            })
            .catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'Error fetching user settings - UserActions');
            });
    },

    getUserAndSettings() {
        let userData = {};

        return dispatch => dispatch(UserActions.getUser({ pageWithSensitiveInformation: true }))
            .then((response = {}) => {
                userData = { ...response };

                if (userData.hasStrongAuthentication) {
                    return dispatch(UserActions.getAccountSettings());
                }
                return userData;
            })
            .then((response = {}) => {
                userData = extend(userData, response);

                const user = User(userData);

                dispatch(UserActions.updateUserInfo(user));

                return user;
            })
            .catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'Error fetching user with settings - UserActions');
            });
    },

    enableTwoFactorAuth({ contactType, phoneNumber }) {
        return dispatch => dispatch(api.users.twoFactorAuth.enableAndRequestCode({
            type: contactType === 'text' ? 'SMS' : 'CALL',
            phone: phoneNumber,
        }))
            .then((response = {}) => {
                if (response && response.success) {
                    return { success: true };
                }
                return { success: false };
            });
    },

    disableTwoFactorAuth() {
        return dispatch => dispatch(api.users.twoFactorAuth.disable());
    },

    requestTwoFactorVerificationCode(contactType) {
        return (dispatch) => {
            const typeForApi = contactType === 'text' ? 'SMS' : 'CALL';

            return dispatch(api.users.twoFactorAuth.requestCode(typeForApi))
                .then((response = {}) => {
                    if (response && response.success) {
                        return { success: true };
                    }
                    return { success: false };
                });
        };
    },

    submitTwoFactorVerificationCode(code) {
        return dispatch => dispatch(api.users.twoFactorAuth.verifyCode(code))
            .then((response = {}) => {
                if (response && response.success) {
                    return { success: true };
                }
                return { success: false, error: 'Invalid code.' };
            });
    },

    updateUserInfo(data) {
        return dispatch => dispatch({
            type: DispatchConstants.UPDATE_USER_INFO,
            payload: data,
        });
    },
    // Hotpads
    logoutUser(hostname) {
        return () => new Promise((resolve, reject) => {
            const options = {
                method: 'delete',
                url: `${hostname}/node/api/cookies?trace=true`,
            };

            axios(options)
                .then(() => {
                    // Success will redirect user to hotpads.com
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    insertAction(params) {
        return dispatch => dispatch(api.users.intention.insertAction(params))
            .then((response = {}) => {
                if (response && response.success) {
                    return { success: true };
                }
                return { success: false };
            }).catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'Error with insertAction - UserActions');
            });
    },
    reportSpam(params) {
        return dispatch => dispatch(api.users.reportSpam(params))
            .then((response = {}) => {
                if (response && response.success) {
                    return { success: true };
                }
                return { success: false };
            }).catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'Error with reportSpam - UserActions');
            });
    },
    trackEvent(params) {
        return dispatch => dispatch(api.users.trackEvent(params))
            .then((response = {}) => {
                return { success: response && response.success };
            }).catch((err) => {
                global.TEMPORARY_global_logger.error(err, 'Error with trackEvent - UserActions');
            });
    },
};

export default UserActions;
